import React, { FC, useState } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { FooterLink } from '../../../../types/types';
import { FooterLinkModel } from '../../../../lib/shared-models/FooterLink.model';
import { LinksAccordionProps } from './types/linksAccordion.types';
import { iconSize } from '../../../../constants/icon.constants';
import { windowService } from '../../../../utils/window.utils';
import { googleClickNavEvent } from '../../../../utils/analytics';
import Icon from '../../../@shared/icon';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';

const LinksAccordion: FC<LinksAccordionProps> = ({ fields, sitecoreContext }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const mobileBreakpoint = 768;
  const isEEActive = sitecoreContext.pageEditing;
  const onAccordionClick = (): void => {
    if (windowService().innerWidth <= mobileBreakpoint) {
      setIsCollapsed(!isCollapsed);
    }
  };

  const accordions = fields?.map((item: FooterLink) => {
    const model = new FooterLinkModel(item);
    const links = model.list?.map((linkItem: FooterLink) => (
      <li key={linkItem?.id} className="footer-accordion__item">
        <RoutableSitecoreLink
          field={linkItem?.fields?.link}
          className="footer-accordion__link"
          onClick={(): void => {
            googleClickNavEvent(
              'Global Footer',
              model?.link?.value?.title ?? model?.link?.value?.text,
              linkItem?.fields?.link?.value?.title ?? linkItem?.fields?.link?.value?.text
            );
          }}
        />
      </li>
    ));

    return (
      <div className="footer-accordion" key={item?.id}>
        <button
          className={'footer-accordion__button' + (model.hasLink ? '' : ' footer-accordion__button--is-plain-text')}
          onClick={onAccordionClick}
        >
          {links?.length > 0 && (
            <Icon
              extraClassName="footer-accordion__icon"
              iconName={isCollapsed ? 'arrow-chevron-down' : 'arrow-chevron-up'}
              size={iconSize.dsk}
            />
          )}
          <div className="footer-accordion__header">
            {isEEActive || model.hasLink ? <RoutableSitecoreLink field={model.link} /> : <span>{model.linkText}</span>}
          </div>
        </button>
        <ul className={`footer-accordion__list ${isCollapsed ? 'footer-accordion__list--collapsed' : ''}`}>{links}</ul>
      </div>
    );
  });

  return <div className="footer-accordion__container">{accordions}</div>;
};

export default withSitecoreContext()(LinksAccordion);
